import * as React from "react";

import {
  MessageWrapper,
  StyledIncomingMessage,
  StyledOutgoingMessage,
  StyledMessageAvatar,
} from "./styles";
import assets from "../../assets/index";
import { useBookingEngine } from "../../context/BookingEngineContext";

export interface MessageProps {
  messageContent: string | undefined;
  variant?: "incoming" | "outgoing";
}

export const Message = ({ messageContent, variant }: MessageProps) => {
  const { bookingEngineData } = useBookingEngine();

  const hostLogo = bookingEngineData?.logoImage?.urls?.big ?? assets.Logo;
  const MessageComponent =
    variant === "incoming" ? StyledIncomingMessage : StyledOutgoingMessage;

  const extractTextFromHTML = (html: string): string => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const textContent = messageContent ? extractTextFromHTML(messageContent) : "";

  return (
    <MessageWrapper variant={variant}>
      {variant !== "incoming" && (
        <StyledMessageAvatar>
          <img src={hostLogo} width={30} alt="logo" />
        </StyledMessageAvatar>
      )}
      <MessageComponent>
        <p>{textContent}</p>
      </MessageComponent>
    </MessageWrapper>
  );
};
